import ms from 'ms';

import { useDebouncedState } from '@hooks';

import usePaginatedQuery from './usePaginatedQuery';

export default (
  resource,
  { page, perPage, sort, date, initialQuery, query: controlledQuery,isWas = false, ...otherVariables } = {},
  { debounce = 300, ...queryConfig } = {},
) => {
  // This doesn't look really good but there is no other good option
  // useQuery is refetching automatically on each query key change, so we need debounce not the API function
  // but the query key change
  // There is also an option to make useQuery manual and debounce function that fire query fetch
  // But that's a lot of hassle by manually listen to the dependent query keys and manually firing query
  const [uncontrolledQuery, setUncontrolledQuery] = useDebouncedState(initialQuery, debounce);

  if (controlledQuery && uncontrolledQuery) {
    console.warn(`You can't use setQuery from resource hook when passing explicitly a controlled query`);
  }

  const query = controlledQuery || uncontrolledQuery;
  const apiMethod = isWas ? resource.api.getWasList : resource.api.getList;
  const {
    resolvedData = resource.api.getEmptyList(),
    latestData = resource.api.getEmptyList(),
    ...other
  } = usePaginatedQuery(
    [resource.name, { page, perPage, sort, date, query, ...otherVariables }],
    apiMethod,
    {
      cacheTime: ms('1m'),
      ...queryConfig,
    },
  );

  return {
    resolvedData,
    latestData,
    setQuery: setUncontrolledQuery,
    ...other,
  };
};
